import * as React from "react";

export default () => {
  return <div>Kontrollera att uppgifterna stämmer.</div>;
};
